import { Injectable } from '@angular/core';
import { BaseService } from '@library-shared/base/base.service';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

import { catchError } from 'rxjs/operators';
import { extTicket_Search_Request } from '@models/External/ext-ticket-search-request';
import { ApiReturn } from '@library-shared/models/api-return';
import { ApiRecordsReturn } from '@library-shared/models/api-records-return';
import { spTicket_List } from '@models/StoredProcs/spTicket_List';
import { spTicket_List_Selected } from '@models/StoredProcs/spTicket_List_Selected';
import { ApiRecordReturn } from '@library-shared/models/api-record-return';
import { Ticket_Search_Response } from '@models/Utility/ticket-search-response';

@Injectable({
    providedIn: 'root',
})
export class TicketService extends BaseService {
    private apiURL = environment.apiURL + '/api/ticket'; // URL to web api

    Ticket_Search(req: extTicket_Search_Request): Observable<ApiRecordReturn<Ticket_Search_Response>> {
        const url = `${this.apiURL}/Ticket_Search`;
        return this.http
            .post<ApiRecordReturn<Ticket_Search_Response>>(url, req, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    Ticket_List(): Observable<ApiRecordsReturn<spTicket_List>> {
        const url = `${this.apiURL}/Ticket_List`;
        return this.http
            .post<ApiRecordsReturn<spTicket_List>>(url, {}, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }

    Ticket_Set_Selected_To_Pay(req: { ticket_session_list?: string[] }): Observable<ApiReturn> {
        const url = `${this.apiURL}/Ticket_Set_Selected_To_Pay`;
        return this.http.post<ApiReturn>(url, req, this.requestOptions).pipe(catchError((e) => this.handleError(e)));
    }

    Ticket_List_Selected(): Observable<ApiRecordsReturn<spTicket_List_Selected>> {
        const url = `${this.apiURL}/Ticket_List_Selected`;
        return this.http
            .post<ApiRecordsReturn<spTicket_List_Selected>>(url, {}, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }
}
